import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSupportConfig, patchbilling, patchScheduling, patchSupport, patchFeedback } from "src/redux/services/commonServices";
import { setSupportConfig } from "src/redux/actions/configurationActions";
import { generateSupportConfigs } from "src/latest/src/core/SupportConfigHandler";
import "./PracticeProfile.scss";
import editIcon from "src/assets/icons/icon-edit.svg";
import { Typography } from "src/latest/src/components";

export const PracticeContactInformation: React.FC = () => {
    const practiceSupport: any = useSelector(
        (state: any) => state?.configuration?.practiceSupport
    );
    const dispatch = useDispatch();

    const fetchSupportConfig = async () => {
        const appConfig: any = await getSupportConfig();
        const supportConfig: any = generateSupportConfigs(appConfig?.config_models);

        dispatch(setSupportConfig(supportConfig));
    };

    useEffect(() => {
        fetchSupportConfig();
    }, []);

    const [editSupportEmail, setEditSupportEmail] = useState(false);
    const [editSupportPhone, setEditSupportPhone] = useState(false);
    const [newSupportEmail, setNewSupportEmail] = useState('');
    const [newSupportPhone, setNewSupportPhone] = useState('');
    const [editingSupportHover, setEditingSupportHover] = useState(false);
    const [editSchedulingEmail, setEditSchedulingEmail] = useState(false);
    const [editSchedulingPhone, setEditSchedulingPhone] = useState(false);
    const [newSchedulingEmail, setNewSchedulingEmail] = useState('');
    const [newSchedulingPhone, setNewSchedulingPhone] = useState('');
    const [editingSchedulingHover, setEditingSchedulingHover] = useState(false);
    const [editBillingEmail, setEditBillingEmail] = useState(false);
    const [editBillingPhone, setEditBillingPhone] = useState(false);
    const [newBillingEmail, setNewBillingEmail] = useState('');
    const [newBillingPhone, setNewBillingPhone] = useState('');
    const [editingBillingHover, setEditingBillingHover] = useState(false);
    const [editFeedbackEmail, setEditFeedbackEmail] = useState(false);
    const [editFeedbackPhone, setEditFeedbackPhone] = useState(false);
    const [newFeedbackEmail, setNewFeedbackmail] = useState('');
    const [newFeedbackPhone, setNewFeedbackPhone] = useState('');
    const [editingFeedbackHover, setEditingFeedbackHover] = useState(false);

    useEffect(() => {

        if (practiceSupport?.SCHEDULING) {
            setNewSchedulingEmail(practiceSupport?.SCHEDULING?.email);
            setNewSchedulingPhone(practiceSupport?.SCHEDULING?.phone);
        }

        if (practiceSupport?.PROVIDER_REMATCHED) {
            setNewSupportEmail(practiceSupport?.PROVIDER_REMATCHED?.email);
            setNewSupportPhone(practiceSupport?.PROVIDER_REMATCHED?.phone);
        }

        if (practiceSupport?.BILLING) {
            setNewBillingEmail(practiceSupport.BILLING.email || '');
            setNewBillingPhone(practiceSupport.BILLING.phone || '');
        }

        if (practiceSupport?.FEEDBACK) {
            setNewFeedbackmail(practiceSupport?.FEEDBACK?.email || '');
            setNewFeedbackPhone(practiceSupport?.FEEDBACK?.phone || '');
        }

    }, [practiceSupport]);

    const handleSchedulingEmailSubmit = async () => {
        await patchScheduling({ title: 'For questions about scheduling', email: newSchedulingEmail, phone: newSchedulingPhone });
        setEditSchedulingEmail(false);
    };

    const handleSchedulingPhoneSubmit = async () => {
        await patchScheduling({ title: 'For questions about scheduling', email: newSchedulingEmail, phone: newSchedulingPhone });
        setEditSchedulingPhone(false);
    };

    const handleSupportEmailSubmit = async () => {
        await patchSupport({ title: 'For requests to be rematched with a different therapist', email: newSupportEmail, phone: newSupportPhone });
        setEditSupportEmail(false);
    };

    const handleSupportPhoneSubmit = async () => {
        await patchSupport({ title: 'For requests to be rematched with a different therapist', email: newSupportEmail, phone: newSupportPhone });
        setEditSupportPhone(false);
    };

    const handleBillingEmailSubmit = async () => {
        await patchbilling({ title: 'For questions about billing', email: newBillingEmail, phone: newBillingPhone });
        setEditBillingEmail(false);
    };

    const handleBillingPhoneSubmit = async () => {
        await patchbilling({ title: 'For questions about billing', email: newBillingEmail, phone: newBillingPhone });
        setEditBillingPhone(false);
    };

    const handleFeedbackEmailSubmit = async () => {
        await patchFeedback({ title: 'To share feedback about your experience with i2iConnect', email: newFeedbackEmail, phone: newFeedbackPhone });
        setEditFeedbackEmail(false);
    };

    const handleFeedbackPhoneSubmit = async () => {
        await patchFeedback({ title: 'To share feedback about your experience with i2iConnect', email: newFeedbackEmail, phone: newFeedbackPhone });
        setEditFeedbackPhone(false);
    };

    return (
        <div className="">
            <div className="practice-profile__container ">
                <Typography
                    variant="size-14"
                    className="ch-color"
                    weight="bold"
                >
                    {"CONTACT INFORMATION"}
                </Typography>

                <div className="mainclass d-flex" style={{ marginTop: "15px" }}>
                    <div className="mid1" style={{ width: '50%' }}>
                        <div className="">
                            <Typography variant="size-16"
                                className="sh-weight">Scheduling</Typography>
                            {editSchedulingEmail ? (
                                <input
                                    type="text"
                                    value={newSchedulingEmail}
                                    onChange={(e) => setNewSchedulingEmail(e.target.value)}
                                    onBlur={handleSchedulingEmailSubmit}
                                    className="contanct-input-field"
                                />
                            ) : (
                                <div className="mt-1 hovercontainer"
                                    onMouseEnter={()=>setEditingSchedulingHover(true)}
                                    onMouseLeave={()=>setEditingSchedulingHover(false)}
                                    onClick={()=>(setEditSchedulingEmail(true))}>
                                    {editingSchedulingHover && <img src={editIcon} alt="Edit Icon" className="edit-icon-1" />}
                                    <Typography className="mt-1">{newSchedulingEmail}</Typography>
                                </div>
                            )}
                        </div>
                        <div>
                            {editSchedulingPhone ? (
                                <input
                                    type="text"
                                    value={newSchedulingPhone}
                                    onChange={(e)=>setNewSchedulingPhone(e.target.value)}
                                    onBlur={handleSchedulingPhoneSubmit}
                                    className="mt-1 contanct-input-field"
                                />
                            ) : (
                                <div className="mt-1 hovercontainer"
                                    onMouseEnter={()=>setEditingSchedulingHover(true)}
                                    onMouseLeave={()=>setEditingSchedulingHover(false)}
                                    onClick={()=>setEditSchedulingPhone(true)}>
                                    {editingSchedulingHover && <img src={editIcon} alt="Edit Icon" className="edit-icon-1" />}
                                    <Typography>{newSchedulingPhone}</Typography>
                                </div>
                            )}
                        </div>
                        <div className="">
                            <div style={{ marginTop: "16px" }} ><Typography variant="size-16" className="sh-weight">Support</Typography></div>
                            <div>
                                {
                                    editSupportEmail ? (
                                        <input
                                            type="text"
                                            value={newSupportEmail}
                                            onChange={(e)=>setNewSupportEmail(e.target.value)}
                                            onBlur={handleSupportEmailSubmit}
                                            className="contanct-input-field"
                                        />
                                    ) : (
                                        <div
                                            className="mt-1 hovercontainer"
                                            onClick={()=>setEditSupportEmail(true)}
                                            onMouseEnter={()=>setEditingSupportHover(true)}
                                            onMouseLeave={()=>setEditingSupportHover(false)}
                                        >
                                            {editingSupportHover && <img src={editIcon} alt="Edit Icon" className="edit-icon-1" />}
                                            <Typography className="mt-1">{newSupportEmail}</Typography>

                                        </div>
                                    )
                                }
                            </div>
                            <div>
                                {editSupportPhone ? (
                                    <input
                                        type="text"
                                        value={newSupportPhone}
                                        onChange={(e)=>setNewSupportPhone(e.target.value)}
                                        onBlur={handleSupportPhoneSubmit}
                                        className="contanct-input-field"
                                    />
                                ) : (
                                    <div
                                        className="mt-1 hovercontainer"
                                        onClick={()=>setEditSupportPhone(true)}
                                        onMouseEnter={()=>setEditingSupportHover(true)}
                                        onMouseLeave={()=> setEditingSupportHover(false)}
                                    >
                                        {editingSupportHover && <img src={editIcon} alt="Edit Icon" className="edit-icon-1" />}
                                        <Typography>{newSupportPhone}</Typography>
                                    </div>
                                )
                                }
                            </div>
                        </div>
                    </div>
                    <div className="mid2 " style={{ width: '50%' }}>
                        <div className="">
                            <div>
                                <Typography variant="size-16" className="sh-weight">Billing</Typography>
                                {editBillingEmail ? (
                                    <input
                                        type="text"
                                        value={newBillingEmail}
                                        onChange={(e)=>setNewBillingEmail(e.target.value)}
                                        onBlur={handleBillingEmailSubmit}
                                        className="contanct-input-field"
                                    />
                                ) : (
                                    <div className="mt-1 hovercontainer"
                                        onMouseEnter={()=>setEditingBillingHover(true)}
                                        onMouseLeave={()=>setEditingBillingHover(false)}
                                        onClick={()=> setEditBillingEmail(true)}><Typography className="hoverdiv">{newBillingEmail}</Typography>
                                        {editingBillingHover && <img src={editIcon} alt="Edit Icon" className="edit-icon-1" />}
                                    </div>
                                )}
                            </div>
                            <div>
                                {editBillingPhone ? (
                                    <input
                                        type="text"
                                        value={newBillingPhone}
                                        onChange={(e)=> setNewBillingPhone(e.target.value)}
                                        onBlur={handleBillingPhoneSubmit}
                                        className="mt-1 contanct-input-field"
                                    />
                                ) : (
                                    <div className="mt-1 hovercontainer"
                                        onMouseEnter={()=>setEditingBillingHover(true)}
                                        onMouseLeave={()=>setEditingBillingHover(false)}
                                        onClick={()=>setEditBillingPhone(true)}><Typography>{newBillingPhone}</Typography>
                                        {editingBillingHover && <img src={editIcon} alt="Edit Icon" className="edit-icon-1" />}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="">
                            <div style={{ marginTop: "16px" }}><Typography className="sh-weight"> Feedback</Typography></div>
                            {editFeedbackEmail ? (
                                <input
                                    type="text"
                                    value={newFeedbackEmail}
                                    onChange={(e)=>setNewFeedbackmail(e.target.value)}
                                    onBlur={handleFeedbackEmailSubmit}
                                    className="contanct-input-field"
                                />
                            ) : (
                                <div className="mt-1 hovercontainer"
                                    onMouseEnter={()=>setEditingFeedbackHover(true)}
                                    onMouseLeave={()=>setEditingFeedbackHover(false)}
                                    onClick={()=>setEditFeedbackEmail(true)}><Typography className="hoverdiv mt-1">{newFeedbackEmail}</Typography>
                                    {editingFeedbackHover && <img src={editIcon} alt="Edit Icon" className="edit-icon-1" />}
                                </div>
                            )}
                        </div>
                        <div>
                            {editFeedbackPhone ? (
                                <input
                                    type="text"
                                    value={newFeedbackPhone}
                                    onChange={(e)=>setNewFeedbackPhone(e.target.value)}
                                    onBlur={handleFeedbackPhoneSubmit}
                                    className="mt-1 contanct-input-field"
                                />
                            ) : (
                                <div className="mt-1 hovercontainer"
                                    onMouseEnter={()=>setEditingFeedbackHover(true)}
                                    onMouseLeave={()=>setEditingFeedbackHover(false)}
                                    onClick={()=>setEditFeedbackPhone(true)}><Typography>{newFeedbackPhone}</Typography>
                                    {editingFeedbackHover && <img src={editIcon} alt="Edit Icon" className="edit-icon-1" />}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
